<template>
  <PageVC class="restaurants-overview" :class="classObject">
    <div class="restaurants-overview__inner">
      <div class="restaurants-overview__map">
        <img
          class="restaurants-overview__map-image"
          :src="mapImageSrc"
          :class="{'cached': mapImageCached}"
          @load="handleMapLoaded"
        />
      </div>
      <ul>
        <li
          class="restaurants-overview__overview-item"
          v-for="restaurant in restaurants"
          :key="'restaurant-item' + restaurant.name"
        >
          <router-link
            class="restaurants-overview__overview-item-link"
            :to="{ name: 'RESTAURANT', params: { restaurantSlug: restaurant.slug }}"
          >
            <span
              class="restaurants-overview__overview-item-marker"
              :style="'left: ' + restaurant.map_position_x + '%; margin-top: ' + restaurant.map_position_y + '%'"
            >
              <HUIIconLogo />
            </span>
            <div>
              {{ restaurant.name }}
              <br />
              {{ restaurant.address }}
            </div>
            <HUIIconArrowLeft class="restaurants-overview__overview-item-link-icon"></HUIIconArrowLeft>
          </router-link>
        </li>
      </ul>
    </div>
  </PageVC>
</template>

<script>
import { mapState } from 'vuex'
import { HUILoadingView, HUIIconArrowLeft, HUIIconLogo } from '@/halifax-ui'
import PageVC from '@/containers/PageVC'
import { ORIGIN } from '@/api'

export default {
  components: {
    PageVC,
    HUILoadingView,
    HUIIconArrowLeft,
    HUIIconLogo
  },
  data() {
    return {
      mapLoaded: false,
      mapImageCached: false,
      mapImageSrc: `${ORIGIN}/img/restaurants.png`
    }
  },
  created() {
    const [performanceResourceTimingForSrc] = performance.getEntriesByName(this.mapImageSrc)
    this.mapImageCached = !!performanceResourceTimingForSrc
  },
  computed: {
    ...mapState('restaurant', {
      restaurants: 'restaurants'
    }),
    classObject() {
      return {
        'restaurants-overview--map-loaded': this.mapLoaded
      }
    }
  },
  methods: {
    handleMapLoaded() {
      this.mapLoaded = true
    }
  }
}
</script>

<style lang="scss">
@import '~@/halifax-ui/src/scss/framework';
@import '~@/scss/variables';

.restaurants-overview {
  $module: '.restaurants-overview';

  &__inner {
    position: relative;
    max-width: $max-width-container - ($padding-x-container * 2);
    margin-left: auto;
    margin-right: auto;
  }
  &__map {
    margin-top: -$padding-top-page-vc;
    background-color: #ddd5be;
    position: relative;
    border-bottom: 1px solid #c9c3b2;

    &::after {
      content: '';
      display: block;
      padding-top: percentage(580 / 750);
    }
  }
  &__map-image {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;

    &:not(.cached) {
      opacity: 0;
      transition: 500ms opacity;
      transition-delay: 250ms;
    }
    #{$module}--map-loaded & {
      opacity: 1;
    }
  }
  &__overview-item {
    border-top: 1px solid rgba($text-color, 0.2);

    &:first-of-type {
      border-top: none;
    }
    &:last-of-type {
      border-bottom: 1px solid rgba($text-color, 0.2);
    }
  }
  &__overview-item-marker {
    position: absolute;
    width: 38px;
    padding: 5px;
    border-radius: 100px;
    top: 0;
    background: rgba(#000, 0);
    display: block;
    opacity: 0;
    transition: 200ms opacity, 200ms transform $easeOutBack;
    transform: translate(-50%, -50%) scale(0);

    #{$module}--map-loaded & {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
    #{$module}__overview-item-link:active & {
      background: rgba(#000, 0.1);
    }
    svg {
      width: 100%;
      height: 100%;
      display: block;
      background: $background-light-70;
      border-radius: 100px;
      padding: 2px;
      color: $halifax-red;
    }

    @for $i from 1 through 20 {
      #{$module}__overview-item:nth-last-child(#{$i}) & {
        transition-delay: 50ms * ($i - 1) + 250ms;
      }
    }
  }
  &__overview-item-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px;
    text-decoration: none;
    cursor: pointer;

    &:active {
      background-color: hsla(0, 0%, 0%, 0.03);
    }

    > div:first-line {
      font-size: 2rem;
      font-weight: 700;
    }
  }
  &__overview-item-link-icon {
    transform: rotate(180deg);
    width: 16.7px;
  }
}
</style>
